
export const Sleep = (millis: number) =>
{
	return new Promise<void>((res) =>
	{
		setTimeout(res, millis);
	});
}

